import { fileService } from "@/api/services/fileService.ts";
import type { File } from "@supplier/entity";
import WangEditor from "@/sassLogin/pages/WangEditor/index.vue";

/**富文本数据管理 */
class EditorManage {
    /**富文本ID占位符 */
    static ID_PLACEHOLDER = "==ids=";
    /**富文本ID分隔符 */
    static ID_SEP = "--";
    /**富文本正则 */
    static ID_REG = new RegExp(`^${EditorManage.ID_PLACEHOLDER}(.*?)\\n`);
    /**路径ID正则 */
    static PATH_ID_SEP_REG = /#/;

    /**获取富文本文件id */
    getIds(content?: string) {
        if (!content) {
            return [];
        }
        const match = content.match(EditorManage.ID_REG);
        if (match) {
            return match[1].split(EditorManage.ID_SEP).map(Number);
        }
        return [];
    }
    /**获取富文本真实内容 */
    async getRealContent(content: string) {
        if (!content) {
            return content;
        }
        const _content = content.replace(EditorManage.ID_REG, "");

        // 定义正则表达式，用来匹配<img>和<video>标签的src属性
        const regex = /<(img|video|source)\s+[^>]*src=["']([^"']+)["']/g;

        // 遍历所有的图片标签，并提取src属性
        const imageSources = [] as string[];
        let match;
        while ((match = regex.exec(_content)) !== null) {
            // const tag = match[1]; // img或video
            const src = match[2]; // src属性的值
            imageSources.push(src);
        }
        const mediasSources = Array.from(new Set([...imageSources]));
        const mediasObjs = [] as { id: number; src: string }[];
        const mediasIds = mediasSources
            .map(src => {
                const pathList = src.split(EditorManage.PATH_ID_SEP_REG);
                const id = Number(pathList[1]);
                if (id) {
                    mediasObjs.push({ id, src });
                }
                return id;
            })
            .filter(Boolean);

        if (!mediasIds.length) {
            return _content;
        }

        // 通过ids获取新的path
        let data = await fileService.getFileByIds(mediasIds);
        const newPaths = data.map((file: File) => file.path + "#" + file.id);

        let newContent = _content;
        mediasObjs.forEach((item, index) => {
            let lastIndex = 0;
            while (newContent.indexOf(item.src, lastIndex) > -1) {
                newContent = newContent.replace(item.src, newPaths[index]);
                lastIndex = newContent.indexOf(item.src, lastIndex) + 1;
            }
        });

        return newContent;
    }
    /**为富文本内容挂载id */
    setContent(content?: string, ids: number[] = []) {
        if (!content || !ids.length) {
            return content;
        }
        return `${EditorManage.ID_PLACEHOLDER}${ids.join(EditorManage.ID_SEP)}\n${content}`;
    }
    /**处理富文本图片与视频宽度 */
    handleContentWidth(content?: string) {
        if (!content) {
            return content;
        }
        return content
            .replace(/<img/gi, '<img style="width:100%;height:auto"')
            .replace(/<video/gi, '<video style="width:100%;height:auto"');
    }
    /** 处理视频居中 */
    handleVideoCenter(content?: string) {
        if (!content) {
            return content;
        }
        return content
            .replace(/<video/gi, '<div style="width:100%; display: flex; justify-content: center;"><video')
            .replace(/\/video>/gi, "/video></div>");
    }
    /**获取请求formId */
    getFormIds(wangEditorInstance: InstanceType<typeof WangEditor> | undefined, lastFileIds: number[]) {
        if (!wangEditorInstance) {
            return { activeFileIds: [], unActiveFileIds: lastFileIds };
        }
        const activeFileIds = Array.from(
            new Set(
                [
                    ...(wangEditorInstance.editor.getElemsByType("image") || []),
                    ...(wangEditorInstance.editor.getElemsByType("video") || [])
                ].map(item => {
                    const pathList = item.src.split(EditorManage.PATH_ID_SEP_REG);
                    return Number(pathList[1]);
                })
            )
        ).filter(Boolean) as number[];
        const unActiveFileIds = lastFileIds.filter(id => !activeFileIds.includes(id)) || [];
        return { activeFileIds, unActiveFileIds };
    }
}

export const editorManage = new EditorManage();
